import { Controller } from "@hotwired/stimulus";

// Une page rendue depuis le cache de Turbo (bouton « Précédent ») garde le
// badge de la cloche tel qu'il était à la première visite : une notification
// lue entre-temps y restait comptée. On redemande alors le nombre au serveur,
// ainsi que la liste du menu.
let lastVisitAction = null;
document.addEventListener("turbo:visit", (event) => {
  lastVisitAction = event.detail.action;
});

export default class extends Controller {
  static targets = ["badge"];

  connect() {
    // L'aperçu d'une visite ordinaire est aussitôt remplacé par la page fraîche.
    if (document.documentElement.hasAttribute("data-turbo-preview")) return;
    if (lastVisitAction !== "restore") return;

    this.refresh();
  }

  async refresh() {
    try {
      const response = await fetch("/notifications/unread_count", {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      if (!response.ok) return;

      const { count } = await response.json();
      if (count === parseInt(this.badgeTarget.dataset.count || "0", 10)) return;

      this.badgeTarget.dataset.count = count;
      this.badgeTarget.textContent = count > 9 ? "9+" : count;
      this.badgeTarget.classList.toggle("hidden", count === 0);
      this.reloadList();
    } catch (_error) {
      // Badge laissé tel quel : la prochaine page le recalculera.
    }
  }

  async reloadList() {
    const response = await fetch("/notifications/dropdown_content", {
      headers: { Accept: "text/vnd.turbo-stream.html" },
      credentials: "same-origin",
    });
    if (response.ok && window.Turbo) {
      window.Turbo.renderStreamMessage(await response.text());
    }
  }
}
